export const normalizeAuthUser = (data) => {
  let user = null;
  let token = null;

  if (data.user && data.token) {
    user = data.user;
    token = data.token;
  } else if (data.data && data.data.user && data.data.token) {
    user = data.data.user;
    token = data.data.token;
  } else if (data.user && data.user.token) {
    user = data.user;
    token = data.user.token;
  } else if (data.user) {
    user = data.user;
    token = data.token || data.access_token || null;
  } else if (data.email) {
    user = {
      id: data.id,
      email: data.email,
      name: data.name || data.email.split("@")[0],
      username: data.username || data.email.split("@")[0],
      role: data.role || "USER",
    };
    token = data.token || data.access_token || null;
  }

  if (!user || !user.email) {
    return null;
  }

  return {
    id: user.id || data.id || null,
    name:
      user.name ||
      user.fullName ||
      (user.email || data.email).split("@")[0],
    email: user.email || data.email,
    username:
      user.username ||
      user.name?.split(" ")[0] ||
      (user.email || data.email).split("@")[0],
    token: token || data.token || data.access_token || null,
    role: user.role || data.role || "USER",
  };
};
